module.exports = __webpack_public_path__ + "bin/4dff2f19a9fcf9f16f247bde58f1464f.jpg";